module.exports = __webpack_public_path__ + "static/media/Nelson_Dumas.3dc1e399.png";